"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestError = void 0;
/**
 * Any TypeError that is thrown if network request is not performed correctly
 * e.g. Network Error as a result of HttpBaseApi's get, post, put or delete method
 * thrown back as an instance of this error class
 */
class RequestError extends TypeError {
    name = 'RequestError';
    url;
    /**
     * Create an instance of RequestError
     * @param {TypeError} error The original TypeError instance which caused this error
     * @param {string} url URL of the request
     */
    constructor(error, url) {
        super(error.message);
        this.url = url;
        this.cause = error;
        if (error.stack) {
            this.stack = error.stack;
        }
    }
}
exports.RequestError = RequestError;
